/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Text, View } from "@aws-amplify/ui-react";
export default function HomePage(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="10px"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "HomePage")}
      {...rest}
    >
      <Flex
        gap="0"
        direction="column"
        width="400px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "AutoLayout")}
      >
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="space-between"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
          padding="20px 20px 20px 20px"
          backgroundColor="rgba(59,135,165,1)"
          {...getOverrideProps(overrides, "ButtonSection")}
        >
          <View
            width="100px"
            height="100px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "ItemsButton")}
          >
            <Text
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              color="rgba(0,34,102,1)"
              lineHeight="21px"
              textAlign="center"
              display="block"
              direction="column"
              justifyContent="unset"
              width="100px"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="calc(50% - 10.5px - -35.5px)"
              left="calc(50% - 50px - 0px)"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Objets"
              {...getOverrideProps(overrides, "itemsLabel")}
            ></Text>
            <View
              width="66px"
              height="66px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              position="absolute"
              top="-2px"
              left="17px"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "itemsIcon")}
            >
              <Icon
                width="51.44px"
                height="32.85px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 51.4384765625,
                  height: 32.8504638671875,
                }}
                paths={[
                  {
                    d: "M37.0253 16.4209C36.1213 16.4209 35.2894 16.4209 34.4575 16.4209C32.3348 16.4209 30.2122 16.4175 28.0895 16.4209C27.1064 16.4227 26.7334 16.7973 26.7317 17.7856C26.7283 20.5098 26.7317 23.2323 26.7317 25.9566C26.7317 26.1869 26.7317 26.4189 26.7317 26.7163C26.4258 26.7163 26.1748 26.7111 25.9256 26.7163C25.0714 26.7369 24.6795 27.1253 24.6761 27.9933C24.6675 29.5986 24.6744 31.2039 24.6744 32.8505L0 32.8505L0 0L51.4095 0C51.4181 0.182188 51.437 0.38672 51.437 0.59297C51.437 5.89016 51.4456 11.1873 51.4216 16.4828C51.4216 16.8008 51.2445 17.1686 51.0366 17.423C50.5794 17.985 50.05 18.4886 49.433 19.1417C49.4055 18.7756 49.3814 18.5969 49.3814 18.4181C49.378 16.8317 49.3831 15.2436 49.378 13.6572C49.3745 12.6758 48.9998 12.3045 48.0098 12.3028C44.7941 12.2994 41.5766 12.2994 38.3608 12.3028C37.412 12.3028 37.0322 12.6827 37.0253 13.6245C37.0184 14.5234 37.0253 15.4223 37.0253 16.4192L37.0253 16.4209ZM25.7727 4.06656C23.3939 4.06656 21.0169 4.06656 18.6381 4.06656C18.5952 4.06656 18.5522 4.06656 18.5092 4.06656C16.2147 4.13188 14.4083 5.91594 14.3808 8.14516C14.3533 10.3331 16.1116 12.2513 18.37 12.2788C23.253 12.3372 28.1394 12.3458 33.0223 12.2788C35.6538 12.2427 37.4361 9.83813 36.9016 7.2686C36.5217 5.43985 34.8339 4.09063 32.8419 4.07172C30.4855 4.05109 28.1291 4.06656 25.7727 4.06656Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="23.45%"
                bottom="26.78%"
                left="8.03%"
                right="14.04%"
                {...getOverrideProps(overrides, "Vector41724593")}
              ></Icon>
              <Icon
                width="30.82px"
                height="18.45px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 30.823974609375,
                  height: 18.4490966796875,
                }}
                paths={[
                  {
                    d: "M30.8241 0L30.8241 18.4491L0 18.4491L0 0L30.8241 0ZM15.443 2.01093C14.1367 2.01093 12.8288 1.99547 11.5225 2.01953C11.1014 2.02813 10.6631 2.08656 10.2644 2.22062C8.92203 2.67265 8.03 4.11297 8.22766 5.43469C8.47172 7.06062 9.70063 8.16922 11.3558 8.18297C14.0559 8.20531 16.7544 8.19672 19.4545 8.17953C19.8309 8.17781 20.2228 8.09187 20.5803 7.9664C21.9192 7.49375 22.7975 6.04828 22.5809 4.73343C22.3163 3.12468 21.1131 2.04875 19.4906 2.01781C18.1414 1.99203 16.7905 2.01265 15.4412 2.01093L15.443 2.01093Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="67.12%"
                bottom="4.93%"
                left="48.58%"
                right="4.72%"
                {...getOverrideProps(overrides, "Vector41724594")}
              ></Icon>
              <Icon
                width="12.26px"
                height="8.18px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 12.261474609375,
                  height: 8.1795654296875,
                }}
                paths={[
                  {
                    d: "M12.2616 8.17953L0 8.17953L0 0L12.2616 0L12.2616 8.17953Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="51.49%"
                bottom="36.11%"
                left="51.71%"
                right="29.71%"
                {...getOverrideProps(overrides, "Vector41724595")}
              ></Icon>
              <Icon
                width="8.19px"
                height="10.88px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 8.19482421875,
                  height: 10.8831787109375,
                }}
                paths={[
                  {
                    d: "M4.07859 10.8831C4.07859 9.8639 4.07859 9.01484 4.07859 8.16578C4.07859 6.96437 4.05797 5.76469 4.08203 4.56328C4.13188 2.03328 4.02016 1.97312 1.50906 2.02641C1.01922 2.03672 0.529375 2.02641 0 2.02641L0 0L8.19328 0C8.19328 0.223437 8.19328 0.448593 8.19328 0.67375C8.19328 2.53859 8.20016 4.40516 8.18469 6.27C8.18297 6.50547 8.12625 6.80625 7.97671 6.96094C6.73921 8.23797 5.4725 9.48578 4.07859 10.8797L4.07859 10.8831Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="45.25%"
                bottom="38.26%"
                left="67.3%"
                right="20.28%"
                {...getOverrideProps(overrides, "Vector41724596")}
              ></Icon>
              <Icon
                width="12.12px"
                height="9.64px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 12.115478515625,
                  height: 9.637451171875,
                }}
                paths={[
                  {
                    d: "M9.62671 0.00172043C10.3658 0.737345 11.2252 1.59328 12.1155 2.48016C12.0089 2.59703 11.8731 2.75687 11.7253 2.90297C9.63531 4.99469 7.53672 7.07781 5.46219 9.185C5.13047 9.52188 4.80047 9.64563 4.33812 9.63703C2.83937 9.61125 1.34063 9.62672 0 9.62672C3.16594 6.45906 6.40406 3.22094 9.625 0L9.62671 0.00172043Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="49.34%"
                bottom="36.06%"
                left="76.21%"
                right="5.43%"
                {...getOverrideProps(overrides, "Vector41724597")}
              ></Icon>
              <Icon
                width="2.48px"
                height="1.02px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 2.478515625,
                  height: 1.016845703125,
                }}
                paths={[
                  {
                    d: "M2.47843 1.01679L0 1.01679C0.532812 -0.0883673 1.45922 -0.0780548 2.47843 0.0714765L2.47843 1.01679Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="62.33%"
                bottom="36.13%"
                left="88.38%"
                right="7.86%"
                {...getOverrideProps(overrides, "Vector41724598")}
              ></Icon>
              <Icon
                width="18.53px"
                height="4.12px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 18.5283203125,
                  height: 4.1190185546875,
                }}
                paths={[
                  {
                    d: "M9.24868 4.11667C6.89227 4.11667 4.53415 4.12011 2.17774 4.11667C0.886963 4.11495 -0.0102245 3.2487 8.79851e-05 2.02839C0.0104005 0.84761 0.911026 0.00370339 2.17603 0.00198464C6.91118 0.000265891 11.6463 -0.00145286 16.3815 0.00198464C17.6327 0.00198464 18.5282 0.868235 18.5282 2.05761C18.5282 3.24698 17.6327 4.11323 16.3832 4.11667C14.0045 4.12183 11.6257 4.11667 9.24868 4.11667Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="32.73%"
                bottom="61.03%"
                left="32.93%"
                right="39%"
                {...getOverrideProps(overrides, "Vector41724599")}
              ></Icon>
              <Icon
                width="10.29px"
                height="2.06px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 10.292724609375,
                  height: 2.0614013671875,
                }}
                paths={[
                  {
                    d: "M5.1429 0.00185856C6.46978 0.00185856 7.79837 -0.00330126 9.12524 0.00357374C9.87634 0.00701124 10.3077 0.405764 10.2923 1.05889C10.2768 1.67764 9.85056 2.05748 9.13212 2.05748C6.47665 2.06264 3.8229 2.06264 1.16743 2.05748C0.418056 2.05748 -0.015068 1.65357 0.000400736 1.00217C0.0141507 0.383417 0.440399 0.00701124 1.15884 0.00357374C2.48571 -0.00330126 3.8143 0.00185856 5.14118 0.00185856L5.1429 0.00185856Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="73.28%"
                bottom="23.59%"
                left="64.12%"
                right="20.28%"
                {...getOverrideProps(overrides, "Vector41724600")}
              ></Icon>
            </View>
          </View>
          <View
            width="100px"
            height="100px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "ReceiptsButton")}
          >
            <Text
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              color="rgba(0,34,102,1)"
              lineHeight="21px"
              textAlign="center"
              display="block"
              direction="column"
              justifyContent="unset"
              width="100px"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="calc(50% - 10.5px - -35.5px)"
              left="calc(50% - 50px - 0px)"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Factures"
              {...getOverrideProps(overrides, "receiptsLabel")}
            ></Text>
            <View
              width="48px"
              height="49.85px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              position="absolute"
              top="16px"
              left="26px"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "receiptsIcon")}
            >
              <Icon
                width="45.75px"
                height="49.67px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 45.752197265625,
                  height: 49.6688232421875,
                }}
                paths={[
                  {
                    d: "M30.1744 49.6677L3.89111 49.6677C3.79111 49.6277 3.69556 49.5765 3.59222 49.5509C1.45111 49.0079 0.0133333 47.2043 0.0111111 44.9913C0.00333334 31.2602 0.00777778 17.5281 0 3.797C0 3.48546 0.0833333 3.29965 0.363333 3.13387C2.03333 2.14696 3.69444 1.1467 5.34222 0.12752C5.64444 -0.0594028 5.85 -0.0293616 6.13222 0.143097C7.75556 1.13334 9.39667 2.09244 11.0133 3.09159C11.3633 3.30744 11.6033 3.29297 11.9456 3.08046C13.5456 2.08688 15.1722 1.1378 16.7722 0.14421C17.0911 -0.0538397 17.3056 -0.0326995 17.61 0.154224C19.2278 1.15226 20.8656 2.11803 22.4822 3.11718C22.7922 3.30855 23.0122 3.29965 23.3189 3.1105C24.9044 2.12916 26.5111 1.18119 28.0956 0.197616C28.4478 -0.0215732 28.7022 -0.052727 29.0778 0.182039C30.6589 1.16784 32.2744 2.10023 33.86 3.07935C34.2011 3.29075 34.4378 3.30966 34.79 3.09047C36.3878 2.09466 38.0133 1.14225 39.6167 0.155336C39.9189 -0.0304743 40.1333 -0.0560649 40.4533 0.14421C42.0344 1.13112 43.6289 2.098 45.2378 3.03929C45.6244 3.26516 45.7522 3.51661 45.7522 3.95722C45.7389 12.2475 45.7422 20.5389 45.7422 28.8291L45.7422 29.4477C45.6044 29.4388 45.5289 29.4477 45.4633 29.4266C42.3967 28.423 39.2644 28.3429 36.1033 28.788C34.2044 29.055 32.3922 29.6057 30.8022 30.7217C29.4 31.7053 28.5078 32.9959 28.51 34.7884C28.5144 38.2487 28.56 41.7101 28.4911 45.1704C28.4556 46.934 28.8478 48.4561 30.1756 49.6688L30.1744 49.6677ZM22.8567 18.4694C26.6622 18.4694 30.4689 18.4694 34.2744 18.4694C34.9211 18.4694 35.5678 18.4816 36.2144 18.466C37.0911 18.4449 37.7678 17.7795 37.8022 16.9283C37.8356 16.1217 37.2022 15.4185 36.3522 15.3295C36.1144 15.305 35.8733 15.3017 35.6333 15.3017C27.1156 15.3006 18.5989 15.3006 10.0811 15.3017C9.82333 15.3017 9.56444 15.315 9.30667 15.3373C8.76333 15.3862 8.37667 15.6855 8.12889 16.1506C7.54333 17.2443 8.35222 18.466 9.66556 18.4671C14.0622 18.4716 18.46 18.4682 22.8567 18.4694ZM20.2456 28.1193C23.46 28.1193 26.6744 28.1193 29.8889 28.1193C30.2589 28.1193 30.6289 28.1371 30.9967 28.1104C31.9011 28.0436 32.5333 27.3905 32.5444 26.5382C32.5556 25.697 31.98 25.0606 31.0911 24.9405C30.9089 24.916 30.7222 24.9204 30.5378 24.9204C23.6833 24.9204 16.83 24.9193 9.97556 24.9226C9.71889 24.9226 9.45667 24.9349 9.20667 24.9872C8.41556 25.1507 7.94111 25.7738 7.96556 26.5816C7.99333 27.5073 8.69778 28.1159 9.77 28.117C13.2622 28.1215 16.7533 28.1181 20.2456 28.1193ZM15.5589 34.5648C13.6211 34.5648 11.6833 34.5481 9.74556 34.5792C9.36111 34.5859 8.93556 34.7027 8.60778 34.8997C8.01444 35.2557 7.81111 36.0023 8.02444 36.661C8.24889 37.353 8.85667 37.7447 9.77111 37.7458C13.61 37.7514 17.4489 37.7514 21.2878 37.7413C21.5767 37.7413 21.8833 37.698 22.1511 37.5945C22.8533 37.3241 23.2156 36.6031 23.0789 35.8365C22.9511 35.1189 22.2922 34.5737 21.4822 34.5681C19.5078 34.5559 17.5322 34.5637 15.5578 34.5637L15.5589 34.5648Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0.36%"
                bottom="0%"
                left="0.44%"
                right="4.24%"
                {...getOverrideProps(overrides, "Vector41724622")}
              ></Icon>
              <Icon
                width="16.61px"
                height="4.95px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 16.606689453125,
                  height: 4.9534912109375,
                }}
                paths={[
                  {
                    d: "M6.56717 4.95346C5.63383 4.76876 4.67828 4.65527 3.77272 4.37823C2.90161 4.11119 2.04939 3.73401 1.24717 3.29897C0.376057 2.82721 -0.101721 2.06617 0.0182792 1.01027C0.0571681 0.668694 0.0238368 0.318214 0.0238368 0C5.54606 2.43223 11.0249 2.4211 16.5138 0.0278159C16.8272 1.97716 16.3849 2.86281 14.6194 3.73623C13.3305 4.37378 11.9449 4.6575 10.5327 4.83886C10.3549 4.86111 10.1816 4.91452 10.0072 4.95346L6.56939 4.95346L6.56717 4.95346Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="90.06%"
                bottom="0%"
                left="65.33%"
                right="0.07%"
                {...getOverrideProps(overrides, "Vector41724623")}
              ></Icon>
              <Icon
                width="16.6px"
                height="7.08px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 16.59716796875,
                  height: 7.08447265625,
                }}
                paths={[
                  {
                    d: "M8.26565 6.92645C6.2401 6.90197 4.23899 6.685 2.37454 5.84941C1.68454 5.5401 1.02343 5.08281 0.475654 4.55875C-0.186568 3.92455 -0.129902 3.06337 0.475654 2.36352C1.29788 1.41222 2.41343 0.962709 3.5801 0.653395C7.09343 -0.27677 10.5934 -0.26119 14.0257 1.00722C14.7323 1.26869 15.4134 1.71708 15.9779 2.22222C16.8257 2.98215 16.7801 3.9379 15.9812 4.75236C15.1634 5.58572 14.1212 6.04524 13.019 6.28223C11.4579 6.61825 9.86787 6.82297 8.2901 7.08444C8.28232 7.03215 8.27454 6.97874 8.26676 6.92645L8.26565 6.92645Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="62.83%"
                bottom="22.96%"
                left="65.31%"
                right="0.11%"
                {...getOverrideProps(overrides, "Vector41724624")}
              ></Icon>
              <Icon
                width="16.58px"
                height="5px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 16.581787109375,
                  height: 4.9954833984375,
                }}
                paths={[
                  {
                    d: "M16.5402 0.0144648C16.5402 0.564108 16.6524 1.16604 16.508 1.699C16.3724 2.19635 16.0491 2.71706 15.6602 3.05753C14.6347 3.95431 13.3447 4.32927 12.0358 4.59519C9.03577 5.20269 6.05133 5.15485 3.12577 4.20132C2.38355 3.95877 1.67466 3.56712 1.00799 3.15099C0.313549 2.71706 -0.0686712 2.05726 0.0102177 1.18384C0.0457733 0.786633 0.0157719 0.38386 0.0157719 0C5.53577 2.44001 11.0002 2.43222 16.5391 0.0155752L16.5402 0.0144648Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="78.39%"
                bottom="11.59%"
                left="65.34%"
                right="0.11%"
                {...getOverrideProps(overrides, "Vector41724625")}
              ></Icon>
            </View>
          </View>
          <View
            width="100px"
            height="100px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "AdsButton")}
          >
            <Text
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              color="rgba(0,34,102,1)"
              lineHeight="21px"
              textAlign="center"
              display="block"
              direction="column"
              justifyContent="unset"
              width="100px"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="calc(50% - 10.5px - -35.5px)"
              left="calc(50% - 50px - 0px)"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Annonces"
              {...getOverrideProps(overrides, "adsLabel")}
            ></Text>
            <View
              width="59px"
              height="60.04px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              position="absolute"
              top="8px"
              left="15px"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "adsIcon")}
            >
              <Icon
                width="59px"
                height="60.03px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 59.000244140625,
                  height: 60.033935546875,
                }}
                paths={[
                  {
                    d: "M17.7237 20.1171C16.4009 19.1437 15.1149 18.196 13.8261 17.2511C10.2925 14.6567 6.72764 12.1056 3.24155 9.45008C1.83462 8.3789 0.691152 7.02126 0.206332 5.22917C-0.168486 3.83894 -0.017744 2.49622 0.537694 1.19832C0.939673 0.258825 1.98265 -0.174264 3.03649 0.0646815C4.0686 0.298196 4.92823 0.854831 5.60318 1.62326C7.58456 3.87967 9.551 6.15101 11.4577 8.47122C14.1398 11.735 16.7622 15.049 19.4647 18.4092C20.4452 17.4412 21.3782 16.5316 22.2976 15.6084C24.5791 13.3139 23.8878 13.747 26.8117 13.7158C28.9384 13.6941 31.0664 13.7335 33.1945 13.7022C33.9862 13.69 34.5647 14.0063 35.1011 14.544C38.6769 18.1309 42.2648 21.7069 45.8459 25.287C49.9404 29.3803 54.0336 33.4723 58.1226 37.571C59.281 38.7331 59.2973 39.6631 58.143 40.8239C53.967 45.0204 49.7761 49.2033 45.5906 53.3889C43.6418 55.3385 41.6863 57.2813 39.7402 59.2336C38.6728 60.3034 37.6366 60.3007 36.5624 59.2254C31.1927 53.8532 25.8217 48.4838 20.4506 43.1129C18.0686 40.7316 15.6662 38.372 13.3277 35.9486C12.9447 35.5522 12.6623 34.8842 12.6473 34.3344C12.5781 31.6666 12.6188 28.9948 12.612 26.3256C12.6107 25.5789 12.8836 24.9802 13.4187 24.4589C14.7129 23.1962 15.9854 21.9106 17.2647 20.6317C17.4059 20.4905 17.5322 20.3343 17.725 20.1185L17.7237 20.1171ZM47.7974 37.833C47.8002 31.7141 42.9465 26.8442 36.8462 26.8442C30.8043 26.8442 25.8434 31.7793 25.9154 37.8792C25.9873 44.0212 30.8776 48.7064 36.8272 48.7322C42.9017 48.758 47.7947 43.8786 47.7974 37.833ZM18.5915 19.2917C18.6485 19.2414 18.7055 19.1926 18.7626 19.1423C18.6336 18.959 18.5208 18.7622 18.3755 18.5938C16.8369 16.8194 15.2466 15.087 13.7609 13.2691C11.5623 10.5769 9.49396 7.77475 7.25591 5.11648C6.14504 3.79685 4.83317 2.6252 3.50908 1.51193C2.6087 0.754365 1.72055 1.1603 1.43536 2.29937C0.999427 4.04123 1.324 5.64596 2.52179 6.97374C3.39365 7.94038 4.34292 8.86901 5.38182 9.6483C9.62569 12.8306 13.9185 15.9505 18.1949 19.0894C18.3131 19.1763 18.4597 19.2251 18.5928 19.2917L18.5915 19.2917ZM19.7553 23.0442C19.758 24.3407 20.7956 25.3807 22.0653 25.359C23.3473 25.3373 24.34 24.2959 24.3265 22.9885C24.3129 21.7123 23.3229 20.7308 22.045 20.7308C20.7453 20.7308 19.7512 21.7341 19.7553 23.0455L19.7553 23.0442Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="0%"
                left="0%"
                right="0%"
                {...getOverrideProps(overrides, "Vector41724647")}
              ></Icon>
              <Icon
                width="17.58px"
                height="17.51px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 17.581298828125,
                  height: 17.5130615234375,
                }}
                paths={[
                  {
                    d: "M8.80565 0.00874387C13.4583 -0.120232 17.5976 3.81151 17.5813 8.75606C17.565 13.6205 13.5031 17.4871 8.84503 17.5129C4.11498 17.54 0.256791 13.6572 0.0137017 9.26381C-0.283709 3.89161 4.31189 -0.215268 8.80429 0.00874387L8.80565 0.00874387ZM7.96231 8.77506C6.77266 8.77506 5.66993 8.76556 4.56721 8.77778C3.7551 8.78728 3.21053 9.3154 3.21188 10.058C3.21188 10.8265 3.71979 11.2908 4.58894 11.2949C6.05698 11.3016 7.52501 11.2976 8.99441 11.2949C10.0347 11.2935 10.4855 10.8604 10.4896 9.82995C10.4964 7.7066 10.495 5.58459 10.4896 3.46124C10.4869 2.56383 9.99664 1.98955 9.25787 1.98412C8.44441 1.97869 7.96502 2.51903 7.96502 3.44902C7.96502 5.18545 7.96502 6.92187 7.96502 8.77506L7.96231 8.77506Z",
                    fill: "rgba(36,83,101,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="48.39%"
                bottom="22.44%"
                left="47.6%"
                right="22.6%"
                {...getOverrideProps(overrides, "Vector41724648")}
              ></Icon>
            </View>
          </View>
        </Flex>
        <View
          width="unset"
          height="471px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Infos")}
        >
          <Text
            fontFamily="Inter"
            fontSize="14px"
            fontWeight="400"
            color="rgba(92,102,112,1)"
            lineHeight="21px"
            textAlign="center"
            display="block"
            direction="column"
            justifyContent="unset"
            width="365px"
            height="unset"
            gap="unset"
            alignItems="unset"
            position="absolute"
            top="442px"
            left="18px"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Ajouter objets / factures"
            {...getOverrideProps(overrides, "Ajouter")}
          ></Text>
          <Flex
            gap="0"
            direction="column"
            width="360px"
            height="50px"
            justifyContent="center"
            alignItems="center"
            overflow="hidden"
            position="absolute"
            top="387px"
            left="20px"
            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 8px 0px"
            backgroundColor="rgba(59,135,165,1)"
            {...getOverrideProps(overrides, "AddButton")}
          >
            <Text
              fontFamily="Inter"
              fontSize="64px"
              fontWeight="700"
              color="rgba(255,255,255,1)"
              lineHeight="96px"
              textAlign="center"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="+"
              {...getOverrideProps(overrides, "+")}
            ></Text>
          </Flex>
          <View
            width="182px"
            height="94px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="271px"
            left="208px"
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(250,250,250,1)"
            {...getOverrideProps(overrides, "AdsDescriptionLabelFrame")}
          >
            <Text
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              color="rgba(92,102,112,1)"
              lineHeight="21px"
              textAlign="justify"
              display="block"
              direction="column"
              justifyContent="unset"
              width="170px"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="5px"
              left="6px"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Les annonces que vous avez créées pour revendre plus vite sur vos réseaux sociaux"
              {...getOverrideProps(overrides, "ItemsDescriptionLabel41633432")}
            ></Text>
          </View>
          <View
            width="180px"
            height="94px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="150px"
            left="110px"
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(250,250,250,1)"
            {...getOverrideProps(overrides, "ReceiptsDescriptionLabelFrame")}
          >
            <Text
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              color="rgba(92,102,112,1)"
              lineHeight="21px"
              textAlign="justify"
              display="block"
              direction="column"
              justifyContent="unset"
              width="170px"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="5px"
              left="5px"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Retrouvez toutes vos factures pour faire jouer une garantie ou retourner un produit"
              {...getOverrideProps(overrides, "ItemsDescriptionLabel41633431")}
            ></Text>
          </View>
          <View
            width="180px"
            height="94px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="29px"
            left="10px"
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="3px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(250,250,250,1)"
            {...getOverrideProps(overrides, "ItemsDescriptionLabelFrame")}
          >
            <Text
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              color="rgba(92,102,112,1)"
              lineHeight="21px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="170px"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="5px"
              left="5px"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Tous ce que vous pouvez faire avec vos objets en 1 clic. Pour les mettre en vente c’est ici !"
              {...getOverrideProps(overrides, "ItemsDescriptionLabel41633433")}
            ></Text>
          </View>
          <View
            padding="0px 0px 0px 0px"
            width="14px"
            height="276px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="-10px"
            left="347px"
            {...getOverrideProps(overrides, "Group 1")}
          >
            <Icon
              width="14px"
              height="14px"
              viewBox={{ minX: 0, minY: 0, width: 14, height: 14 }}
              paths={[
                {
                  d: "M7 0L13.0622 10.5L0.937822 10.5L7 0Z",
                  fill: "rgba(239,240,240,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="276px"
              left="14px"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Polygon 141744652")}
            ></Icon>
            <View
              width="2px"
              height="268px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0px"
              left="6px"
              padding="0px 0px 0px 0px"
              backgroundColor="rgba(239,240,240,1)"
              {...getOverrideProps(overrides, "Rectangle 141744653")}
            ></View>
          </View>
          <View
            padding="0px 0px 0px 0px"
            width="14px"
            height="276px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="-131px"
            left="218px"
            {...getOverrideProps(overrides, "Group 2")}
          >
            <Icon
              width="14px"
              height="14px"
              viewBox={{ minX: 0, minY: 0, width: 14, height: 14 }}
              paths={[
                {
                  d: "M7 0L13.0622 10.5L0.937822 10.5L7 0Z",
                  fill: "rgba(239,240,240,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="276px"
              left="14px"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Polygon 141744658")}
            ></Icon>
            <View
              width="2px"
              height="268px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0px"
              left="6px"
              padding="0px 0px 0px 0px"
              backgroundColor="rgba(239,240,240,1)"
              {...getOverrideProps(overrides, "Rectangle 141744659")}
            ></View>
          </View>
          <View
            padding="0px 0px 0px 0px"
            width="14px"
            height="276px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="-252px"
            left="89px"
            {...getOverrideProps(overrides, "Group 3")}
          >
            <Icon
              width="14px"
              height="14px"
              viewBox={{ minX: 0, minY: 0, width: 14, height: 14 }}
              paths={[
                {
                  d: "M7 0L13.0622 10.5L0.937822 10.5L7 0Z",
                  fill: "rgba(239,240,240,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="276px"
              left="14px"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Polygon 141744661")}
            ></Icon>
            <View
              width="2px"
              height="268px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0px"
              left="6px"
              padding="0px 0px 0px 0px"
              backgroundColor="rgba(239,240,240,1)"
              {...getOverrideProps(overrides, "Rectangle 141744662")}
            ></View>
          </View>
        </View>
      </Flex>
    </Flex>
  );
}
